import Vue from 'vue';

Vue.component('ask-lisa', {
    data: function () {
        return {
            isOpen: false,
            selectedInstruction: null
        }
    },

    mounted: function(){
        this.bindOpenButtons();
        this.bindCloseButtons();
        this.bindAutoCompleteSelected();
    },

    methods: {
        bindOpenButtons: function(){
            let self = this;
            let openButtons = document.querySelectorAll("[data-js-ask-lisa-open]");
            let openButtonsLength = openButtons.length;

            for (let i =0; i < openButtonsLength; i++)
            {
                let openButton = openButtons[i];
                openButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.isOpen = true;

                    if( jQuery('.search-dropdown-container').is(":visible") ) {
                        window.EventBus.$emit('autocomplete-closed-via-button');
                    } else {
                        jQuery('.search-dropdown-container').toggleClass('d-none');
                    }

                    this.lazyLoadImages();

                    // Focus on the search input box only when the modal is set to display. Inputs inside hidden elements can not be focused.
                    this.$nextTick(() => {
                        jQuery('.search-dropdown-container input').focus();
                    });
                });
            }

            jQuery('.footer-ask-lisa-link [data-js-ask-lisa-open]').on('click', (e) => {
                e.preventDefault();
                this.isOpen = true;

                window.scrollTo(0, 0);
                document.getElementById('site-container').classList.add('d-none');
                document.body.classList.add('overflow-y-hidden');
                this.$nextTick(() => {
                    jQuery('#ask-lisa-overlay input').focus();
                });
            });
        },

        bindCloseButtons: function(){
            let self = this;
            let closeButtons = document.querySelectorAll("[data-js-ask-lisa-close]");
            let closeButtonsLength = closeButtons.length;

            for (let i =0; i < closeButtonsLength; i++)
            {
                let closeButton = closeButtons[i];
                closeButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.selectedInstruction = null;
                    this.isOpen = false;
                    document.getElementById('site-container').classList.remove('d-none');
                    document.getElementById('ask-lisa-search').value = '';
                    document.body.classList.remove('overflow-y-hidden');
                    window.EventBus.$emit('autocomplete-closed-via-button');
                });
            }
        },

        bindAutoCompleteSelected(){
            var self = this;
            // This event is created by the algolia template 1001-carpet-care-theme/algolia/autocomplete.php
            window.EventBus.$on('autocomplete-selected', function(selectedSuggestion){

                /**
                 * If the selected post is not tips/advice then we will redirect to the post.
                 * Otherwise we will show the tips/advice post in page.
                 */
                if(selectedSuggestion.post_type != 'instructions' && selectedSuggestion.post_type != 'how-to') {
                    window.location = selectedSuggestion.permalink;
                    return;
                }

                // We got back the selected instruction ID from Algolia, now lets load up the data from WordPress
                // via an ajax call.
                var data = {
                    'action': 'instructions_json_data',
                    'instruction_id': selectedSuggestion.post_id
                };
                // We can also pass the url value separately from ajaxurl for front end AJAX implementations
                jQuery.post(Ajax.ajaxUrl, data, function(response) {
                    self.selectedInstruction = jQuery.parseJSON(response);
                    document.getElementById('site-container').classList.add('d-none');
                    document.body.classList.add('overflow-y-hidden');
                    jQuery('.search-dropdown-container').addClass('d-none');
                });
            });
        },

        lazyLoadImages: function(){
            let lazy_load_images = document.querySelectorAll('.lazy_load');
            let lazy_load_images_length = lazy_load_images.length;

            for (let i = 0; i < lazy_load_images_length; i++) {
                let element = lazy_load_images[i];
                element.setAttribute('src', element.getAttribute('data-src'));
            }
        },

        loadSocials: function(){
            this.socialsLoaded = true;
        }
    }
});